import { SortDirection } from "../../supportFunctions/graphql/Queries";

interface GetUserRoleLocationCountFilter {
  customerID: string;
  description?: Array<string>;
  isExplicitlyAssigned?: boolean;
  locationIDs?: Array<string>;
  locationName?: Array<string>;
  roleName?: Array<string>;
  roleDescription?: string;
}

interface GetUsersAssignedToRoleFilter {
  and: {
    customerID: string;
    locationID: string;
    roleID: string;
    displayName?: string;
    userStatus?: Array<"ACTIVE" | "INACTIVE" | "PENDING">;
    isExplicitlyAssigned?: boolean;
  };
}

interface UserAssignedToRole {
  roleID: string;
  roleName: string;
  email: string;
  locationName: string;
  displayName: string;
  userStatus: string;
}

interface LazyParams {
  first: number;
  rows: number;
  page: number;
  sortField: string;
  sortOrder: SortDirection;
  filters: {
    displayName: {
      value: string;
    };
  };
}

enum UserStatuses {
  Active = "Active",
  Inactive = "Inactive",
}

const UserStatusOptions = Object.values(UserStatuses).map((value) => ({
  id: value.toUpperCase(),
  label: value,
}));

enum ExplicitAssigned {
  Yes = "Yes",
  No = "No",
}

const ExplicitAssignedOptions = Object.values(ExplicitAssigned).map(
  (value) => ({
    id: value,
    label: value,
  })
);

interface CustomerRoleFormFields {
  name: string;
  description: string;
}

export {
  GetUserRoleLocationCountFilter,
  GetUsersAssignedToRoleFilter,
  UserAssignedToRole,
  LazyParams,
  UserStatusOptions,
  ExplicitAssignedOptions,
  ExplicitAssigned,
  CustomerRoleFormFields,
};
